module.exports = __webpack_public_path__ + "img/transparent_css.442861ca.png";